import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import JSONDiff from './JSONDiff.js';
const DiffTab = ({ delta, base16Theme, invertTheme, labelRenderer, isWideLayout, dataTypeKey, }) => (_jsx(JSONDiff, { delta,
    base16Theme,
    invertTheme,
    labelRenderer,
    isWideLayout,
    dataTypeKey }));
export default DiffTab;
